import { KeyboardEventHandler } from "react";

export const getButtonRoleProps = <T extends HTMLElement>() => {
  // Mostly cribbed from https://www.w3.org/TR/wai-aria-practices/examples/button/js/button.js
  const onKeyDown: KeyboardEventHandler<T> = evt => {
    if (evt.key === " " || evt.keyCode === 32) {
      evt.preventDefault();
    } else if (evt.key === "Enter" || evt.keyCode === 13) {
      evt.preventDefault();
      evt.currentTarget.click();
    }
  };
  const onKeyUp: KeyboardEventHandler<T> = evt => {
    if (evt.key === " " || evt.keyCode === 32) {
      evt.preventDefault();
      evt.currentTarget.click();
    }
  };

  return { role: "button", tabIndex: 0, onKeyDown, onKeyUp };
};
